// Central site config — easy to edit later.
// HIGHLIGHT: Square booking link is MOCKED. Replace SQUARE_BOOKING_URL with your real Square Appointments link.
export const SQUARE_BOOKING_URL = "https://app.squareup.com/appointments/book/hi91u2dw65f0iq/L39R27W864RTK/start";

// SMS quote — opens the customer's native Messages app pre-filled
export const QUOTE_SMS_NUMBER = "+18169550108";
export const QUOTE_SMS_BODY = "Hi Legacy Auto! I'd like a quote for my [Year / Make / Model]. I've attached photos of the vehicle. Thanks!";
export const QUOTE_SMS_HREF = `sms:${QUOTE_SMS_NUMBER}?&body=${encodeURIComponent(QUOTE_SMS_BODY)}`;

export const SITE = {
  name: "Legacy Auto",
  tagline: "Mobile Detailing — Kansas City",
  logo: "https://customer-assets.emergentagent.com/job_legacy-auto-detail/artifacts/gmosdwpd_A0337F9E-577E-4618-9B8B-E232743C5A31.png",
  phone: "(816) 328-4526",
  email: "legacyautokc@gmail.com",
  address: "Kansas City Metro, MO / KS",
  hours: "Mon–Sat · 8:00 AM – 7:00 PM",
  instagram: "https://www.instagram.com/legacy._auto",
  facebook: "https://www.facebook.com/share/1EvWYe9MFn/?mibextid=wwXIfr",
  bookingUrl: SQUARE_BOOKING_URL,
};

export const SERVICES = [
  {
    key: "standard",
    title: "Standard Detail",
    short: "Full Interior + Exterior",
    price: "$225",
    duration: "2 hr 30 min",
    desc: "Thorough interior clean, vacuumed carpets and seats, all surfaces wiped, crystal-clear windows. Exterior gets a premium hand wash, wheel & tire clean, bug removal, door jambs, and tire shine.",
    span: "md:col-span-2 md:row-span-2",
    img: "https://customer-assets.emergentagent.com/job_legacy-auto-detail/artifacts/kqszwwjl_IMG_0029_under_5MB.jpg",
  },
  {
    key: "premium",
    title: "Premium Detail",
    short: "Deepest Clean + Wax",
    price: "$300",
    duration: "3 hr 30 min",
    desc: "Everything in Standard Detail plus carpet & floor mat shampoo, upholstery and fabric shampoo, deep stain treatment, and a hand-applied wax for added gloss and paint protection.",
    span: "md:col-span-1",
    img: "https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "interior",
    title: "Interior Detail",
    short: "Refresh & restore",
    price: "$125",
    duration: "1 hr 30 min",
    desc: "Vacuum carpets, seats, floor mats and cargo areas, wipe all interior surfaces, clean cup holders and door panels, dust vents, and detail interior windows and mirrors.",
    span: "md:col-span-1",
    img: "https://images.unsplash.com/photo-1645400379459-f6fd3d963fd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4MTgyODY5N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "exterior",
    title: "Exterior Detail",
    short: "Shine restored",
    price: "$100",
    duration: "1 hr 30 min",
    desc: "Hand wash, wheel and tire cleaning, bug and road-grime removal, door jambs cleaned, streak-free windows, and a premium tire dressing for serious gloss.",
    span: "md:col-span-2",
    img: "https://customer-assets.emergentagent.com/job_legacy-auto-detail/artifacts/0s8ycj9r_IMG_9050-2.jpeg",
  },
  {
    key: "ceramic",
    title: "Ceramic Coating",
    short: "Long-term protection",
    price: "$300",
    duration: "2 hr 30 min",
    desc: "Durable ceramic coating that adds deep gloss and protects against water, dirt, UV rays and contaminants — your paint stays cleaner, longer, with enhanced shine.",
    span: "md:col-span-1",
    img: "https://images.unsplash.com/photo-1627667928346-5fc86d099a5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4MTgyODY5N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const PACKAGES = [
  {
    name: "Exterior",
    price: "$100",
    duration: "1 hr 30 min",
    eyebrow: "Quick Shine",
    features: [
      "Premium hand wash",
      "Wheel & tire clean",
      "Bug & road-grime removal",
      "Door jambs cleaned",
      "Streak-free windows",
      "Premium tire dressing",
    ],
  },
  {
    name: "Standard",
    price: "$225",
    duration: "2 hr 30 min",
    eyebrow: "Most Popular",
    highlight: true,
    features: [
      "Full interior + exterior",
      "Vacuum carpets & seats",
      "All interior surfaces wiped",
      "Crystal-clear windows",
      "Wheel, tire & bug cleaning",
      "Door jambs + tire shine",
    ],
  },
  {
    name: "Premium",
    price: "$300",
    duration: "3 hr 30 min",
    eyebrow: "Deepest Clean",
    features: [
      "Everything in Standard",
      "Carpet & floor-mat shampoo",
      "Upholstery & fabric shampoo",
      "Deep stain treatment",
      "Hand-applied wax",
      "Long-lasting gloss & protection",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus T.",
    car: "2022 Audi RS5 · Leawood",
    text: "Pulled into my driveway with a trailer of gear and left my RS5 looking better than the day I drove it off the lot. Worth every penny.",
  },
  {
    name: "Priya K.",
    car: "2019 Tesla Model 3 · Overland Park",
    text: "Coffee stains on white seats — gone. They steamed every inch and even hit spots my last detailer skipped. Booking again.",
  },
  {
    name: "Devon R.",
    car: "1998 Chevy K1500 · KC North",
    text: "Old truck, decades of grime. Two-stage correction made the paint pop like new. These guys actually care.",
  },
];

export const SERVICE_AREAS = [
  "Kansas City, MO", "Kansas City, KS", "Overland Park", "Leawood",
  "Olathe", "Lee's Summit", "Independence", "Liberty",
  "Lenexa", "Shawnee", "Prairie Village", "Mission Hills",
];
